module.exports = __webpack_public_path__ + "static/media/openKitSerial.83af482c.png";